import api from "./api"; 

export const adminlogin = async ({ emailId, password, force }) => {
  const payload = {
    emailId: emailId,
    mobileNumber: emailId,
    password: password,
    ...(force ? { force: true } : {}),
  };
  const response = await api.post("/admin/login", payload);
  return response.data;
};

export const superadminlogin = async ({ emailId, password, force }) => {
  const payload = {
    email: emailId,
    mobile_number: emailId, 
    password: password,
    ...(force ? { force: true } : {}),
  };

  const response = await api.post("/admin/superadminlogin", payload);
  return response.data;
};

export const adminForgotPassword = async (Forgotload) => {
  const response = await api.post("/admin/forgotpassword", Forgotload);
  return response.data;
};

export const superadminForgotPassword = async (Forgotload) => {
  const response = await api.post("/admin/superadminforgotpassword", Forgotload);
  return response.data;
};


export const SuperAdminandAdminLogout = async () => {
  const token = localStorage.getItem("token");
  const response = await api.post("/admin/logout", {}, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const getadmins = async (page = 1, limit = 10) => {
  const res = await api.get(`/admin?page=${page}&limit=${limit}`);
  return res.data;
};

export const addAdmin = async (data) => {
  const res = await api.post("/admin/register", data, {
    headers: { "Content-Type": "application/json" },
  });
  return res.data;
};

export const updateAdmin = async (data) => {
  const res = await api.post("/admin/update", data, {
    headers: { "Content-Type": "application/json" },
  });
  return res.data;
};

export const deleteAdmin = async (adminId) => {
  const res = await api.post(
    "/admin/delete",
    { adminId }, // ✅ body only
    {
      headers: { "Content-Type": "application/json" },
    }
  );
  return res.data;
};

export const getUsersList = async (page = 1, limit = 10) => {
  const res = await api.get(`/users?page=${page}&limit=${limit}`);
  return res.data;
};

export const getUserDetails = async (userId) => {
  const res = await api.post("/users/details", { userId });
  return res.data;
};

export const getStudentRequestlist = async (page = 1, limit = 10) => {
  const res = await api.get(`/users/detailsrequestslist?page=${page}&limit=${limit}`);
  return res.data;
};

export const getStudentCoursesDetails = async (userId) => {
  const res = await api.post("/enrollments/user_courses", { userId });
  return res.data;
};

export const completeStudentRequest = async (detailsId) => {
  const res = await api.post("/users/completerequest", {
    detailsId,
  });
  return res.data;
};

export const addBanner = async (formData) => {
  const res = await api.post("/banners/add", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

export const getBanners = async (page = 1, limit = 10) => {
  const res = await api.get(`/banners?page=${page}&limit=${limit}`);
  return res.data;
};

export const updateBanners = async (formData) => {
  const res = await api.post("/banners/update", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

export const deleteBanner = async (data) => {
  const res = await api.post("/banners/delete", data);
  return res.data;
};

export const addCategories = async (formData) => {
  const res = await api.post("/categories/add", formData,{
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
}

export const getCategories = async (page = 1, limit = 10) => {
  const res = await api.get(`/categories?page=${page}&limit=${limit}`);
  return res.data;
};

export const getCategoriesById = async (categoryId) => {
  const res = await api.post("/categories/details", { categoryId }, {
    headers: { "Content-Type": "application/json" },
  });
  return res.data;
};

export const updateCategories = async (formData) => {
  const res = await api.post("/categories/update", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

export const deleteCategories = async (data) => {
  const res = await api.post("/categories/delete", data);
  return res.data;
};

export const addSubCategories = async (formData) => {
  const res = await api.post("/subcategories/add", formData,{
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
}

export const getSubCategories = async (page = 1, limit = 10) => {
  const res = await api.get(`/subcategories?page=${page}&limit=${limit}`);
  return res.data;
};

export const getSubCategoriesById = async (subcategory_id) => {
  const res = await api.post("/subcategories/details", { subcategory_id }, {
    headers: { "Content-Type": "application/json" },
  });
  return res.data;
};

export const updateSubCategories = async (formData) => {
  const res = await api.post("/subcategories/update", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

export const deleteSubCategories = async (data) => {
  const res = await api.post("/subcategories/delete", data);
  return res.data;
};

export const getSubCategoriesByCategory = async (data) => {
  const res = await api.post("/subcategories/getbycategory", data);
  return res.data;
};

export const addLaws = async (formData) => {
  const res = await api.post("/laws/add", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

export const getLaws = async (page = 1, limit = 10) => {
  const res = await api.get(`/laws?page=${page}&limit=${limit}`);
  return res.data;
};

export const updateLaws = async (formData) => {
  const res = await api.post("/laws/update", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

export const deleteLaws = async (data) => {
  const res = await api.post("/laws/delete", data);
  return res.data;
};

export const getLaswsBySubCategory = async (data) => {
  const res = await api.post("/laws/listbysubcategory", data);
  return res.data;
};

export const addSubjects = async (formData) => {
  const res = await api.post("/subjects/add", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

export const getSubjects = async (page = 1, limit = 10) => {
  const res = await api.get(`/subjects?page=${page}&limit=${limit}`);
  return res.data;
};

export const updateSubjects = async (formData) => {
  const res = await api.post("/subjects/update", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

export const deleteSubjects = async (data) => {
  const res = await api.post("/subjects/delete", data);
  return res.data;
};

export const getSubjectsByLaw = async (data) => {
  const res = await api.post("/subjects/listbylaw", data);
  return res.data;
};

export const addLectures = async (data)=>{
  const res = await api.post("/lectures/add", data, {
    headers: { "Content-Type": "application/json" },
  });
  return res.data;
}
export const getLectures = async (page = 1, limit = 10) => {
  const res = await api.get(`/lectures?page=${page}&limit=${limit}`);
  return res.data;
};

export const updateLectures = async (data) => {
  const res = await api.post("/lectures/update", data, {
    headers: { "Content-Type": "application/json" },
  });
  return res.data;
};

export const deleteLectures = async (data) => {
  const res = await api.post("/lectures/delete", data);
  return res.data;
};

export const addGuestLectures = async (formData) => {
  const res = await api.post("/guest-lectures/add", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

export const getGusestLectures = async (page = 1, limit = 10) => {
  const res = await api.get(`/guest-lectures?page=${page}&limit=${limit}`);
  return res.data;
};

export const getGuestLecturesById = async (guest_lecture_id) => {
  const res = await api.post("/guest-lectures/details", { guest_lecture_id }, {
    headers: { "Content-Type": "application/json" },
  });
  return res.data;
};

export const updateGuestLectures = async (formData) => {
  const res = await api.post("/guest-lectures/update", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

export const deleteGuestLectures = async (data) => {
  const res = await api.post("/guest-lectures/delete", data);
  return res.data;
};

export const addPlans = async (data) => {
  const res = await api.post("/plans/add", data, {
    headers: { "Content-Type": "application/json" },
  });
  return res.data;
};

export const getPlans = async (page = 1, limit = 10) => {
  const res = await api.get(`/plans?page=${page}&limit=${limit}`);
  return res.data;
};

export const getPlansById = async (planId) => {
  const res = await api.post("/plans/getbyid", { planId }, {
    headers: { "Content-Type": "application/json" },
  });
  return res.data;
};

export const updatePlans = async (data) => {
  const res = await api.post("/plans/update", data, {
    headers: { "Content-Type": "application/json" },
  });
  return res.data;
};

export const deletePlans = async (planId) => {
  const res = await api.post("/plans/delete",{ planId },);
  return res.data;
};

export const addCoupon = async (data) => {
  const res = await api.post("/coupons/add", data);
  return res.data;
};

export const getCoupons = async (page = 1, limit = 10) => {
  const res = await api.get(`/coupons?page=${page}&limit=${limit}`);
  return res.data;
};

export const getCouponById = async (couponId) => {
  const res = await api.post("/coupons/details", { couponId });
  return res.data;
};

export const updateCoupon = async (data) => {
  const res = await api.post("/coupons/update", data);
  return res.data;
};

export const deleteCoupon = async (couponId) => {
  const res = await api.post("/coupons/delete", { couponId });
  return res.data;
};


export const addNotes = async (formData) => {
  const res = await api.post("/notes/add", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

export const getNotes = async (page = 1, limit = 10) => {
  const res = await api.get(`/notes?page=${page}&limit=${limit}`);
  return res.data;
};

export const getNotesById = async (notes_id) => {
  const res = await api.post("/notes/details", { notes_id });
  return res.data;
};

export const updateNotes = async (formData) => {
  const res = await api.post("/notes/update", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

export const deleteNotes = async (notes_id) => {
  const res = await api.post("/notes/delete", { notes_id });
  return res.data;
};

export const getPrintednotesoders = async (page = 1, limit = 10) => {
  const res = await api.get(`/notes/orders?page=${page}&limit=${limit}`);
  return res.data;
};

export const updateOrderStatus = async (body) => {
  const res = await api.post("/notes/updateorderstatus", body);
  return res.data;
};

export const addSubjectnotes = async (formData) => {
  const res = await api.post("/subject-notes/add", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return res.data;
};

export const updateSubjectnotes = async (formData) => {
  const res = await api.post("/subject-notes/update", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return res.data;
};

export const getSubjectnotes = async (page = 1, limit = 10) => {
  const res = await api.get(`/subject-notes?page=${page}&limit=${limit}`);
  return res.data;
};

export const deleteSubjectnotes = async (data) => {
  const res = await api.post("/subject-notes/delete", data);
  return res.data;
};

export const addPrelims = async (formData) => {
  const res = await api.post("/prelimes/add", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

export const getPrelims = async (page = 1, limit = 10) => {
  const res = await api.get(`/prelimes?page=${page}&limit=${limit}`);
  return res.data;
};

export const getPrelimsById = async (prelimes_id) => {
  const res = await api.post("/prelimes/details", { prelimes_id }, {
    headers: { "Content-Type": "application/json" },
  });
  return res.data;
};

export const updatePrelims = async (formData) => {
  const res = await api.post("/prelimes/update", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

export const deletePrelims = async (data) => {
  const res = await api.post("/prelimes/delete", data);
  return res.data;
};


export const addMains = async (formData) => {
  const res = await api.post("/mains/add", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

export const getMains = async (page = 1, limit = 10) => {
  const res = await api.get(`/mains?page=${page}&limit=${limit}`);
  return res.data;
};

export const getMainsById = async (mains_id) => {
  const res = await api.post("/mains/details", { mains_id }, {
    headers: { "Content-Type": "application/json" },
  });
  return res.data;
};

export const updateMains = async (formData) => {
  const res = await api.post("/mains/update", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

export const deleteMains = async (data) => {
  const res = await api.post("/mains/delete", data);
  return res.data;
};


export const addMainsTestSeries = async (formData) => {
  const res = await api.post("/mains/addmainstest", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

export const getMainsTestSeries = async (page = 1, limit = 10, mains_id = "") => {
  const res = await api.get(
    `/mains/mainstests?page=${page}&limit=${limit}${mains_id ? `&mains_id=`: ""}`
  );
  return res.data;
};

export const getMainsTestSeriesById = async (mains_test_id) => {
  const res = await api.post("/mains/mainstestdetails", { mains_test_id }, {
    headers: { "Content-Type": "application/json" },
  });
  return res.data;
};

export const updateMainsTestSeries = async (formData) => {
  const res = await api.post("/mains/updatemainstest", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

export const deleteMainsTestSeries = async (data) => {
  const res = await api.post("/mains/deletemainstest", data);
  return res.data;
};

export const addMainsSubjectTests = async (data) => {
  const res = await api.post("/mains/addmainssubjecttest", data, {
    headers: { "Content-Type": "application/json" },
  });
  return res.data;
};

export const getMainsSubjectTests = async (page = 1, limit = 10, mains_test_id = "") => {
  const res = await api.get(
    `/mains/mainssubjecttests?page=${page}&limit=${limit}${mains_test_id ? `&mains_test_id=` : ""}`
  );
  return res.data;
};

export const getMainsSubjectTestsById = async (mains_subject_test_id) => {
  const res = await api.post("/mains/mainssubjecttestdetails", { mains_subject_test_id }, {
    headers: { "Content-Type": "application/json" },
  });
  return res.data;
};

export const updateMainsSubjectTests = async (data) => {
  const res = await api.post("/mains/updatemainssubjecttest", data, {
    headers: { "Content-Type": "application/json" },
  });
  return res.data;
};

export const deleteMainsSubjectTests = async (data) => {
  const res = await api.post("/mains/deletemainssubjecttest", data);
  return res.data;
};

export const getMainsTestsAttempts = async (page = 1, limit = 10) => {
  const res = await api.get(`/mains/mains_attempts?page=${page}&limit=${limit}`);
  return res.data;
};

export const getMainsTestsAttemptsById = async (mains_attempt_id) => {
  const res = await api.post("/mains/attemptdetails", { mains_attempt_id }, {
    headers: { "Content-Type": "application/json" },
  });
  return res.data;
};

export const addQA = async (formData) => {
  const res = await api.post("/qa/add", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

export const getQAByModuleId = async (page = 1, limit = 10) => {
  const res = await api.post(
    `/qa/module/userId?page=${page}&limit=${limit}`,
    { module: "mains", module_type: "MQA" },
    { headers: { "Content-Type": "application/json" } }
  );
  return res.data;
};

export const getQAById = async (qa_id) => {
  const res = await api.post("/qa/details", { qa_id }, {
    headers: { "Content-Type": "application/json" },
  });
  return res.data;
};

export const updateQA = async (formData) => {
  const res = await api.post("/qa/update", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

export const deleteQA = async (data) => {
  const res = await api.post("/qa/delete", data, {
    headers: { "Content-Type": "application/json" },
  });
  return res.data;
};

export const addMainsResults = async (data) => {
  const res = await api.post("/mains/addresult", data, {
    headers: { "Content-Type": "application/json" },
  });
  return res.data;
};


export const addTestTerms = async (data) => {
  const res = await api.post("/test-terms/add", data);
  return res.data;
};

export const getTestTerms = async (page = 1, limit = 10) => {
  const res = await api.get(`/test-terms?page=${page}&limit=${limit}`);
  return res.data;
};

export const updateTestTerms = async (data) => {
  const res = await api.post("/test-terms/update", data);
  return res.data;
};

export const deleteTestTerms = async (test_term_id) => {
  const res = await api.post("/test-terms/delete", { test_term_id });
  return res.data;
};

export const addMockTestSubject = async (formData) => {
  const res = await api.post("/prelimes/addmocktestsubject", formData,{
headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

export const getMockTestSubject = async (page = 1, limit = 10) => {
  const res = await api.get(`/prelimes/mocktestsubjects?page=${page}&limit=${limit}`);
  return res.data;
};

export const getMockTestSubjectById = async (mocktest_subject_id) => {
  const res = await api.post("/prelimes/mocktestsubjectdetails", { mocktest_subject_id });
  return res.data;
};

export const updateMockTestSubject = async (formData) => {
  const res = await api.post("/prelimes/update_mock_test", formData);
  return res.data;
};

export const deleteMockTestSubject = async (data) => {
  const res = await api.post("/prelimes/delete_subject_mock_test", data);
  return res.data;
};

// export const getPrelimesSubjectWiseTests = async (page = 1, limit = 10, mocktest_subject_id = "") => {
//   const res = await api.get(
//     `/prelimes-tests?page=${page}&limit=${limit}&test_type=SMT&mocktest_subject_id=${mocktest_subject_id}`
//   );
//   return res.data;
// };

export const getPrelimesSubjectWiseTests = async (page = 1, limit = 10) => {
  const res = await api.get(`/prelimes-tests?page=${page}&limit=${limit}&test_type=SMT`);
  return res.data;
};
 
export const addPrelimesSubjectWiseTests = async (data) => {
  const res = await api.post("/prelimes-tests/add", data);
  return res.data;
};

export const getQuizzes = async (page = 1, limit = 10) => {
  const res = await api.get(
    `/prelimes-tests?page=${page}&limit=${limit}&test_type=QZ`
  );
  return res.data;
};
 
export const addQuiz = async (data) => {
  const res = await api.post("/prelimes-tests/add", data);
  return res.data;
};

export const getGrandTest = async (page = 1, limit = 10) => {
  const res = await api.get(`/prelimes-tests?page=${page}&limit=${limit}&test_type=GT`);
  return res.data;
};

export const addGrandTest = async (data) => {
  const res = await api.post("/prelimes-tests/add", data);
  return res.data;
};


export const addQuestion = async (data) => {
  const res = await api.post("/prelimes-tests/addquestion", data);
  return res.data;
};
 
export const getQuestion = async (page = 1, limit = 10, prelimes_test_id) => {
  const res = await api.get(
    `/prelimes-tests/getquestionlist?page=${page}&limit=${limit}&prelimes_test_id=${prelimes_test_id}`
  );
  return res.data;
};
 
export const updateQuestion = async (data) => {
  const res = await api.post("/prelimes-tests/updatequestion", data);
  return res.data;
};
 
export const deleteQuestion = async (questionId) => {
  const res = await api.post("/prelimes-tests/deletequestion", { questionId });
  return res.data;
};

export const getAttemptsResults = async (page = 1, limit = 10, test_type = "") => {
  let url = `/prelimes-tests/attempts?page=${page}&limit=${limit}`;
  if (test_type) {
    url += `&test_type=${test_type}`;
  }
  const res = await api.get(url);
  return res.data;
};

export const getlawBySubjects = async (data) => {
  const res = await api.post("/subjects/listbylawforuser",data);
  return res.data;
};


export const addCombinations = async (formData) => {
  const res = await api.post("/combos/create", formData,{
headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

export const getCombinations = async (page = 1, limit = 10) => {
  const res = await api.get(`/combos/list?page=${page}&limit=${limit}`);
  return res.data;
};

export const getCombinationsById = async (combo_id) => {
  const res = await api.get("/combos/details", { params: { combo_id } });
  return res.data;
};

export const updateCombinations = async (formData) => {
  const res = await api.put("/combos/edit", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return res.data;
};

export const deleteCombinations = async (combo_id) => {
  const res = await api.delete("/combos/delete", { data: { combo_id } });
  return res.data;
};

export const sendnotifications = async (data) => {
  const res = await api.post("/notifications/create-admin",data);
  return res.data;
};


// ─── Help Centre / Tickets ───────────────────────────────────────────────────

// export const getTickets = async (page = 1, limit = 10, status = "") => {
//   const params = new URLSearchParams({ page, limit });
//   if (status) params.append("status", status);
//   const res = await api.get(`/tickets/admin/list?${params.toString()}`);
//   return res.data;
// };

export const getTickets = async (page = 1, limit = 10, status = "") => {
  const token = localStorage.getItem("token");
  const params = new URLSearchParams({ page, limit });
  if (status) params.append("status", status);
  const res = await api.get(`/tickets/admin/list?${params.toString()}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return res.data;
};

export const getTicketDetails = async (ticketId) => {
  const res = await api.get(`/tickets/admin/details/${ticketId}`);
  return res.data;
};

export const addAdminMessage = async (data) => {
  const res = await api.post("/tickets/admin/add-message", data);
  return res.data;
};

export const updateTicketStatus = async (data) => {
  const res = await api.post("/tickets/admin/update-status", data);
  return res.data;
};

export const assignTicket = async (data) => {
  const res = await api.post("/tickets/admin/assign", data);
  return res.data;
};

export const markAdminMessagesRead = async (data) => {
  const res = await api.post("/tickets/admin/mark-read", data);
  return res.data;
};

export const updateCallStatus = async (data) => {
  const res = await api.post("/tickets/admin/update-call-status", data);
  return res.data;
};

export const deleteAdminMessage = async (ticketId, messageId) => {
  const res = await api.delete(`/tickets/admin/${ticketId}/message/${messageId}`);
  return res.data;
};

// 📊 Admin Dashboard APIs
export const getAdminDashboard = async (params = {}) => {
  const queryParams = new URLSearchParams();
  if (params.startDate) queryParams.append("startDate", params.startDate);
  if (params.endDate) queryParams.append("endDate", params.endDate);
  if (params.period) queryParams.append("period", params.period);
  if (params.year) queryParams.append("year", params.year);

  const queryStr = queryParams.toString();
  const url = queryStr ? `/admin/dashboard?${queryStr}` : `/admin/dashboard`;
  const res = await api.get(url);
  return res.data;
};

// 🛒 Enrollments / Orders APIs
export const getEnrollmentsList = async (payload = {}) => {
  const res = await api.post("/enrollments/list", payload);
  return res.data;
};

// 📄 Invoices
export const getInvoiceDownloadUrl = (billingId) => {
  const baseURL = process.env.REACT_APP_API_BASE_URL || "https://api.raoslawacademy.com/";
  const cleanBase = baseURL.endsWith("/") ? baseURL.slice(0, -1) : baseURL;
  return `${cleanBase}/billings/invoice/${billingId}`;
};



